import { useContext, useEffect, useState, useRef, Dispatch } from 'react';
import styled from 'styled-components';
import DeleteIcon from '../../../../../../assets/images/svg/delete-icon.svg';
import { ProductListingContext } from '../../../../functions/data_formatting_functions';
import {
  actionSetAllAttributes,
  actionSetListingData,
} from '../../../../store/create_listing_actions';
import { Label } from '../../../../../../styles/style';
import { Fonts } from '../../../../../../config/theme';
import { toast } from 'react-toastify';
import { formatDecimals } from '../../../../../../utils/functions/formatting_functions';
import { BaseNumericAttribute } from '../../../../../../data/types/attributes';
import { ListingState } from '../../../../../../data/types/listings';

type NumericAttributesProps = {
  attribute: BaseNumericAttribute;
  productType: number;
};

export default function NumericAttributes({
  attribute,
  productType,
}: NumericAttributesProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const [multiple, setMultiple] = useState(attribute.is_variable);
  const [values, setValues] = useState(attribute.values);
  const initialRender = useRef(true);

  const [firstRun, setFirstRun] = useState(true);

  const [value, setValue] = useState(
    multiple
      ? ''
      : attribute.values && attribute.values[0]
        ? attribute.values[0]
        : '',
  );

  const [upperLimit] = useState(
    state.data.numeric_attrs.find((x) => x.id === attribute.id)
      ?.hard_upper_limit,
  );

  const [lowerLimit] = useState(
    state.data.numeric_attrs.find((x) => x.id === attribute.id)
      ?.hard_bottom_limit,
  );

  useEffect(() => {
    if (firstRun) {
      setFirstRun(false);
      return;
    }
    setMultiple(false);
  }, [productType]);

  const changeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (!multiple) {
      setValues([e.target.value]);
    }
    // updateStateValues([e.target.value]);
  };
  useEffect(() => {
    setIsVariableForAttribute(multiple);
  }, [values]);

  const setIsVariableForAttribute = (multiple: boolean) => {
    state.data.numeric_attrs?.forEach((x, i: number) => {
      if (x.name_en === attribute.name_en) {
        if (multiple) {
          values.forEach((element: any) => {
            if (
              values.length !== state.data.numeric_attrs[i].values.length ||
              state.data.numeric_attrs[i].values.find(
                (element1: any) => element1 === element,
              ) === undefined
            ) {
              state.data.combinations_table = [];
            }
          });
        } else {
          state.data.combinations_table = [];
        }
        state.data.numeric_attrs[i].is_variable = multiple;
        state.data.numeric_attrs[i].values = values;
        // state.data.numeric_attrs[i].official_values = values;

        dispatch(
          actionSetListingData({
            ...state.data,
            numeric_attrs: [...state.data.numeric_attrs],
            combinations_table: [...state.data.combinations_table],
          }),
        );
      }
    });
    state.all_attributes?.forEach((x: any, i: number) => {
      if (x.name_en === attribute.name_en) {
        state.all_attributes[i].is_variable = multiple;
        state.all_attributes[i].values = values;
        state.all_attributes[i].official_values = values;

        dispatch(actionSetAllAttributes([...state.all_attributes]));
      }
    });
  };

  const onChange = () => {
    setMultiple(!multiple);
  };
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    if (!multiple) {
      if (attribute.values.length !== 0) {
        setValue(attribute.values[0]);
        setValues([attribute.values[0]]);
      } else {
        setValue('');
        setValues([]);
      }
    } else {
      if (value.length !== 0) {
        setValues([value]);
      } else {
        setValues([]);
      }
      setValue('');
    }
  }, [multiple]);
  const addValues = () => {
    if (value === '') {
      toast.warning('Please enter a value');
      return;
    }
    if (
      (upperLimit && Number(value) > parseFloat(upperLimit.toString())) ||
      (lowerLimit && Number(value) < parseFloat(lowerLimit.toString()))
    ) {
      toast.warning(
        `Value should be between ${formatDecimals(
          lowerLimit,
        )} and ${formatDecimals(upperLimit)}`,
      );
      return;
    }
    if (values.includes(value) && multiple) {
      toast.warning(`Already have this value (${value})`);
      return;
    }
    if (multiple) {
      if (!values.includes(value)) {
        setValues([...values, value.split(',')[0]]);
        setValue('');
        // updateStateValues([...values_en, value.split(',')[0]]);
      }
    }
  };
  const removeValue = (index: number) => {
    setValues(values.filter((_: string, i: number) => i !== index));
    // updateStateValues(values.filter((i) => i));
    // dispatch(actionSetListingData({ ...state.data, combinations_table: [] }));
  };

  const remove = () => {
    dispatch(
      actionSetAllAttributes(
        state.all_attributes?.filter(
          (attr) => attr.name_en != attribute.name_en,
        ),
      ),
    );
    dispatch(
      actionSetListingData({
        ...state.data,
        numeric_attrs: state.data.numeric_attrs?.filter(
          (attr) =>
            attr.name_en != attribute.name_en ||
            attr.name_ar != attribute.name_ar,
        ),
      }),
    );
  };

  return (
    <Wrapper>
      <div>
        <div className="between margin">
          <Label
            color="#00273380"
            style={{
              fontSize: '15px',
            }}
          >
            {attribute.name_en}
            {` `}
            {attribute.name_ar !== undefined ? `-${attribute.name_ar}` : ` `}
            {` (${formatDecimals(lowerLimit)} to ${formatDecimals(
              upperLimit,
            )}) `}
            {attribute.unit && ' - ' + attribute.unit}
          </Label>
        </div>

        <div className="flex ">
          <input
            type="number"
            className="form-control input_typeNo "
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder={`${
              multiple
                ? 'Press enter or comma (,) to add values'
                : 'Enter value'
            }`}
            onWheel={() => {}}
            value={value}
            onChange={(e) => changeValue(e)}
            onKeyUp={(e) =>
              e.keyCode == 188 || e.keyCode == 13 ? addValues() : {}
            }
          />
          <div // <Icon
            className={`position-relative info-hover attributes-icons flex ${
              attribute.custom && productType === 1
                ? 'justify-content-between'
                : 'justify-content-end'
            }`}
          >
            {attribute.custom && (
              <img
                src={DeleteIcon}
                alt="delete_icon"
                className="cursor-pointer"
                onClick={remove}
              />
            )}
            {productType === 1 && (
              <div className="checkBoxes flex">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`multiple${attribute.name_en}`}
                    id={`multiple${attribute.name_en}`}
                    checked={multiple}
                    onClick={onChange}
                    onChange={() => {}}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <ValuesStyle>
          {multiple &&
            values?.map((value: string, index: number) => {
              return (
                <span className="p-2 m-1 " key={index}>
                  {value}
                  <i onClick={() => removeValue(index)}>X</i>
                </span>
              );
            })}
        </ValuesStyle>
      </div>
    </Wrapper>
  );
}

const ValuesStyle = styled.div`
  .values {
    padding-top: 10px;
    display: flex;
    justify-content: start;
    width: 20%;
    overflow-wrap: break-word;

    span {
      color: white;
      background: var(--theme-clr);
      border-radius: 3px;
      cursor: pointer;
      padding: 5px;
      margin: 5px;

      i {
        font-size: 10px;
        margin-left: 10px;
        padding: 10px;
        font-weight: bold;
        /* border: 0.5px solid white; */
        /* border-radius: 50%; */
      }
    }
  }
`;
const Wrapper = styled.div`
      .margin {
          margin-top: 10px;
      }
      .flex {
          display: flex;
          align-items: center;
      }
      .justify-content-between {
          /* display: flex; */
          justify-content: space-between;
      }
      .justify-content-end {
          /* display: flex; */
          justify-items: flex-end;
      }
  
      .input_typeNo {
          /* margin-bottom: 18px; */
  
          border: 1px solid #e8e8e8;
          border-radius: 5px;
          width: 100% !important;
          padding: 5px ;
  13px;
          font-family: ${Fonts.secondary};
          font-style: normal;
          font-weight: 400;
          font-size: 17px;
      }
      .position-relative {
          position: relative;
      }
  `;
